import { isEmpty } from "lodash"
import {
  assignAttributeStateToLegends,
  generateLegend,
  legendIDGenerator
} from "../common"
import { LINE_TYPE } from "./lineChart"

export const transformLifecycle = ({
  inputData,
  chartInfo,
  equipmentId,
  oldLegends,
  assignedAttributes = [],
  legendAttributesCombination
}) => {
  const legends = {}
  const data = {}
  const results = inputData?.lifeCycleResults?.results || {}
  const axis = chartInfo?.axisConfig?.find(
    (obj) => obj?.axisName === "lifecycle"
  )
  Object.keys(results)?.forEach((key: string) => {
    const resultObject = results?.[key]

    const legendId = legendIDGenerator(equipmentId, key)
    const legendObj = generateLegend({
      legendId,
      name: key,
      axisName: axis?.axisName,
      symbol: axis?.symbol,
      type: LINE_TYPE,
      oldLegends
    })
    legends[legendId] = legendObj

    const processedData = processLifeCycleData(resultObject)

    data[legendId] = processedData
  })

  assignAttributeStateToLegends(
    legends,
    oldLegends,
    assignedAttributes,
    legendAttributesCombination
  )

  const isNoData = Object.values(data)?.every((arr: any) => !arr?.length)

  const axisList = chartInfo?.axisConfig?.filter(
    (obj) => obj?.axisName === "lifecycle"
  )
  return {
    chartData: {
      data: isNoData ? {} : data
    },
    chartProps: {
      legends: legends,
      axisList: axisList,
      noDataAvailable: isNoData,
      isdataprocessed: true
    }
  }
}

export const processLifeCycleData = (obj) => {
  // Helper function to convert date format from "5-2028" to "01-05-2028"
  const convertDateFormat = (dateStr) => {
    if (
      dateStr.includes("-") &&
      !dateStr.includes("T") &&
      dateStr.split("-").length === 2
    ) {
      const [month, year] = dateStr.split("-")
      // Pad month with leading zero and add day as "01"
      const paddedMonth = month.padStart(2, "0")
      return `01-${paddedMonth}-${year}`
    }
    return dateStr // Return original if already in correct format
  }

  const keys = Object.keys(obj).sort(
    (a, b) =>
      new Date(convertDateFormat(a)).getTime() -
      new Date(convertDateFormat(b)).getTime()
  )

  const events = []

  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    const convertedDateStr = convertDateFormat(k)
    const date = new Date(convertedDateStr)
    const remaining = obj[k]

    if (i === 0) {
      events.push({ date, remaining })
    } else if (i === keys.length - 1) {
      events.push({ date, remaining: 0 })
    } else {
      events.push({ date, remaining })
      events.push({ date, remaining: remaining * 2 })
    }
  }

  return events
}

